import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { TokenService } from '../service/token.service';
import { GlobalService } from '../service/global.service';
import { environment } from 'src/environments/environment';
import { ReportForAccountingDaysInMonthInfo, ReportForAccountingViewInfo } from '../model/reportForAccounting.model';
import { EmpInfo } from '../model/emp.model';
import { SimpleTextInfo } from '../model/simpleTextInfo.model';
import { LookupInfo } from '../model/lookup.model';

@Component({
  selector: 'app-timesheet-report-accounting',
  templateUrl: './timesheet-report-accounting.component.html',
  styleUrls: ['./timesheet-report-accounting.component.css']
})
export class TimesheetReportAccountingComponent implements OnInit {

  baseurl: string;

  //Primary data
  ReportForAccounting: ReportForAccountingViewInfo;
  ListMonth: string[] = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  ListUniqueDate: ReportForAccountingDaysInMonthInfo[] = [];
  ListProjectCode: string[] = [];
  ListProjectCodeForDay: string[] = [];
  ListLeaveType: LookupInfo[] = [];

  //Search Conditions
  ListEmployee: EmpInfo[] = [];
  ListYear: SimpleTextInfo[] = [];

  txtSchEmployee: string = "";
  txtSchYear: string = "";
  txtSchMonth: string = "";

  txtSubmittedEmployee: string = "";
  txtSubmittedYear: string = "";

  //Pagination

  currentTab: any = "Month";
  currentIndex = 0;


  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private GlobalService: GlobalService, private TokenService: TokenService) { 
    this.baseurl = environment.base_api;

    //GlobalService.CheckPagingAccessRights();
  }


  // ngOnInit - start
  // ========================================================================================================
  ngOnInit(): void {
    this.LoadEmployee()
    this.LoadLeaveType()
  }
  // ngOnInit - end
  // ========================================================================================================

    // OnEvent - start
  // ========================================================================================================
  OnSearch_Click() {
    // if(!this.txtSchEmployee || !this.txtSchYear) {
    //   alert("Please select employee and year before submit")
    //   return;
    // }

    if(!this.txtSchEmployee || !this.txtSchYear || this.ListYear.length == 0) return;

    this.LoadReportForAccounting();
    //this.LoadAllTimesheetLists();
    //this.LoadCountTimesheetList();
    this.txtSubmittedEmployee = this.txtSchEmployee
    this.txtSubmittedYear = this.txtSchYear
  }

  OnEmployeeSelected() {
    //console.log(this.txtSchEmployee)
    this.LoadYear();
    this.txtSchYear = "";
    this.txtSchMonth = "";
    this.ReportForAccounting = null;
  }

  OnMonthSelected() {
    var x = this.ReportForAccounting.ListReportForAccounting.filter(x => x.Hours != 0 && this.ListMonth[new Date(x.TimeSheetDate).getMonth()] == this.txtSchMonth)
    this.ListProjectCodeForDay = Array.from(new Set(x.map((item: any) => item.ProjectCode))).sort((a, b) => {  
      return a >= b
        ? 1
        : -1
    })
    this.LoadDaysInMonth()
  }
  // OnEvent - end
  // ========================================================================================================

  // Primary-Data Functions - start
  // ========================================================================================================
  async LoadReportForAccounting() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      //this.Loading(true, 'Loading...');

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['SearchEmployeeCode'] = this.checkUndefinedString(this.txtSchEmployee);
      objectjson['SearchTimeSheetDate'] = this.checkUndefinedString(this.txtSchYear) ? "01-01-"+this.txtSchYear: null;

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<ReportForAccountingViewInfo>(this.baseurl + "TimeSheet/GetReportForAccounting",
          strjson, httpOptions)
        .subscribe({
          next: data => {
            console.log(data)
            this.ReportForAccounting = data

            this.ListProjectCode = Array.from(new Set(data.ListReportForAccounting.map((item: any) => item.ProjectCode))).sort((a, b) => {  
              return a >= b
                ? 1
                : -1
            });

          }
        });
    }
  }

  async LoadEmployee() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['CompanyCode'] = 'DPE';

      let strjson = JSON.stringify(objectjson);

      await this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetEmployeeCriteria", strjson, httpOptions)
        .toPromise().then((data) => {
          this.ListEmployee = data;
          console.log("Emp Loaded:")
          console.log(data)
        });
    }
  }


  async LoadYear() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson["Value"] = this.checkUndefinedString(this.txtSchEmployee)
      

      let strjson = JSON.stringify(objectjson);

      await this.httpClient.post<SimpleTextInfo[]>(this.baseurl + "TimeSheet/GetReportForAccountingSelectableYears", strjson, httpOptions)
        .toPromise().then((data) => {
          this.ListYear = data;
          if(data) $('#txtSchYear').prop('disabled', !!this.txtSchEmployee)
        });
    }
  }

  async LoadDaysInMonth() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson["TimeSheetDate"] = "01-"+this.txtSchMonth+"-"+this.txtSubmittedYear
      objectjson["EmployeeCode"] = this.txtSubmittedEmployee

      let strjson = JSON.stringify(objectjson);

      await this.httpClient.post<ReportForAccountingDaysInMonthInfo[]>(this.baseurl + "TimeSheet/GetReportForAccountingDaysInMonthTemplate", strjson, httpOptions)
        .toPromise().then((data) => {
          this.ListUniqueDate = data;
          console.log("Date Loaded:")
          console.log(data)
        });
    }
  }

  async LoadLeaveType() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['LookupType'] = "LEAVETYPE";

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise().then((data) => {
          this.ListLeaveType = data;
          console.log("Leave type Loaded:")
          console.log(data)
        })
    }
  }

  selectedTabChange(traget) {
    //if (traget.tab.textLabel == 'Worklist') {
    //  this.LoadWorklistTimesheetLists();
    //} else if (traget.tab.textLabel == 'Approval') {
    //  this.LoadApproveTimesheetLists();
    //}
    this.currentTab = traget.tab.textLabel;
    //this.LoadCurrentTabTimesheetLists();
  }



  // Primary-Data Functions - end
  // ========================================================================================================


  // Misc functions - start
  // ========================================================================================================
  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput
  }

  getProjectName(ProjectCode: string) {
    return this.ReportForAccounting.ListReportForAccounting.filter(x => x.ProjectCode == ProjectCode)[0].ProjectName;
  }

  getProjectType(ProjectCode: string) {
    return this.ReportForAccounting.ListReportForAccounting.filter(x => x.ProjectCode == ProjectCode)[0].ProjectType;
  }

  getProjectHoursByMonth(ProjectCode: string, ShortMonth: string) {
    return this.ReportForAccounting.ListReportForAccounting.filter(x => x.ProjectCode == ProjectCode && this.ListMonth[new Date(x.TimeSheetDate).getMonth()] == ShortMonth).reduce((sum, current) => sum + current.Hours, 0);
  }

  getProjectHoursTotal(ProjectCode: string) {
    return this.ReportForAccounting.ListReportForAccounting.filter(x => x.ProjectCode == ProjectCode).reduce((sum, current) => sum + current.Hours, 0);
  }

  getMonthHours(ShortMonth: string) {
    return this.ReportForAccounting.ListReportForAccounting.filter(x => this.ListMonth[new Date(x.TimeSheetDate).getMonth()] == ShortMonth).reduce((sum, current) => sum + current.Hours, 0);
  }

  getYearHours() {
    return this.ReportForAccounting.ListReportForAccounting.reduce((sum, current) => sum + current.Hours, 0);
  }



  //
  getProjectHoursByDay(ProjectCode: string, ConsDate: string) {
    return this.ReportForAccounting.ListReportForAccounting.filter(x => x.ProjectCode == ProjectCode && new Date(x.TimeSheetDate).getDate() == new Date(ConsDate).getDate() && new Date(x.TimeSheetDate).getMonth() == new Date(ConsDate).getMonth()).reduce((sum, current) => sum + current.Hours, 0);
  }
  getDayHours(ConsDate: string) {
    return this.ReportForAccounting.ListReportForAccounting.filter(x => new Date(x.TimeSheetDate).getDate() == new Date(ConsDate).getDate() && new Date(x.TimeSheetDate).getMonth() == new Date(ConsDate).getMonth()).reduce((sum, current) => sum + current.Hours, 0);
  }

  //
  getLeaveTypeCountByMonth(LeaveTypeCode: string, ShortMonth: string) {
    return this.ReportForAccounting.ListReportForAccountingLeave.filter(x => x.LeaveType == LeaveTypeCode && this.ListMonth[new Date(x.TimeSheetDate).getMonth()] == ShortMonth).length;
  }

  getLeaveTypeCount(LeaveTypeCode: string){
    return this.ReportForAccounting.ListReportForAccountingLeave.filter(x => x.LeaveType == LeaveTypeCode).length;
  }

  getLeaveCountByMonth(ShortMonth: string) {
    return this.ReportForAccounting.ListReportForAccountingLeave.filter(x => this.ListMonth[new Date(x.TimeSheetDate).getMonth()] == ShortMonth).length;
  }

  getYearLeaveCount() {
    return this.ReportForAccounting.ListReportForAccountingLeave.length;
  }
  
  // Misc functions - end
  // ========================================================================================================
}
